import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { forwardRef, useState } from "react";
import { TextField } from '../TextField';
export var InputText = forwardRef(function (props, ref) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFieldFocused = _useState2[0],
      setIsFieldFocused = _useState2[1];

  return React.createElement(TextField.Root, null, React.createElement(TextField.Input, Object.assign({}, props, {
    ref: ref,
    isFieldFocused: isFieldFocused,
    onFocus: function onFocus(event) {
      setIsFieldFocused(true);
      props.onFocus && props.onFocus(event);
    },
    onBlur: function onBlur(event) {
      setIsFieldFocused(false);
      props.onBlur && props.onBlur(event);
    },
    endIcon: React.createElement(TextField.Clear, {
      handleClearSearchField: props.handleClearSearchField,
      visible: !!props.value,
      type: 'button'
    })
  })), props.helperMessage && React.createElement(TextField.HelperMessage, {
    variant: props.helperMessageVariant
  }, props.helperMessage));
});